





















import Vue from 'vue';

interface HSProp {
    name: string;
    label: string;
}

export default Vue.extend({
    name: 'PropertySelect',
    props: {
        value: { type: String, default: '' },
        contactProps: { type: Array as () => HSProp[], default: () => [] },
        companyProps: { type: Array as () => HSProp[], default: () => [] }
    },
    data() {
        return {
            isOpen: false,
            activeTab: 'contact',
            search: ''
        }
    },
    computed: {
        currentType(): string {
            const sepIndex = this.value.indexOf('::');
            return sepIndex === -1 ? '' : this.value.substring(0, sepIndex);
        },
        currentName(): string {
            const sepIndex = this.value.indexOf('::');
            return sepIndex === -1 ? '' : this.value.substring(sepIndex + 2);
        },
        currentLabel(): string {
            if(!this.value) return '— Skip —';
            const list = this.currentType === 'CONTACT' ? this.contactProps : this.companyProps;
            const found = list.find(p => p.name === this.currentName);
            return found ? found.label : this.currentName;
        },
        filteredProps(): HSProp[] {
            const list = this.activeTab === 'contact' ? this.contactProps : this.companyProps;
            if(!this.search) return list;
            const q = this.search.toLowerCase();
            return list.filter(p => p.label.toLowerCase().includes(q));
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    },
    methods: {
        toggleOpen() {
            this.isOpen = !this.isOpen;
            if(this.isOpen) {
                this.search = '';
                this.activeTab = this.currentType === 'COMPANY' ? 'company' : 'contact';
            }
        },
        select(prop: HSProp | null) {
            this.$emit('input', prop ? `${this.activeTab === 'contact' ? 'CONTACT' : 'COMPANY'}::${prop.name}` : '');
            this.isOpen = false;
        },
        handleOutsideClick(event: MouseEvent) {
            if(this.isOpen && this.$el && !this.$el.contains(event.target as Node)) {
                this.isOpen = false;
            }
        }
    }
})
